import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App.js'
import { informarDeLaAltura } from './empotrado.js'
import './estilos.css'

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('Falta el <div id="raiz"> en index.html')

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Si la pagina va dentro de un iframe (la web de SunSmart), le dice cuanto mide
// para que el recuadro crezca y encoja con el formulario. Fuera de un iframe no hace nada.
informarDeLaAltura()
